// src/firebaseConfig.js
import firebase from "firebase";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCezohm0OAWJyECYOYzR_VTImkxGoukimQ",
  authDomain: "ibaka-tv.firebaseapp.com",
  databaseURL: "https://ibaka-tv.firebaseio.com",
  projectId: "ibaka-tv",
  storageBucket: "ibaka-tv.appspot.com",
  messagingSenderId: "169277392468",
  appId: "1:169277392468:web:5b436515ce2c1c0adccfc1",
  measurementId: "G-93LHEXHNCW",
};

// Initialize Firebase
export default firebase.initializeApp(firebaseConfig);
